import { noop } from "lodash";
import { type ChangeEvent, forwardRef, useEffect, useState } from "react";
import { NumberFormatBase } from "react-number-format";

import { type InputProps, Input as TextInput } from "../ui/input";

export type IbanInputProps = Omit<InputProps, "value"> & {
  value?: string | null;
};

export const IbanInput = forwardRef<HTMLInputElement, IbanInputProps>(
  (
    { placeholder, value: _value, onChange = noop, defaultValue, ...props },
    ref,
  ) => {
    const [value, setValue] = useState(_value);

    useEffect(() => {
      setValue(_value);
    }, [_value]);

    return (
      <NumberFormatBase
        {...props}
        placeholder={placeholder}
        getInputRef={ref}
        type="text"
        value={value}
        format={(value) =>
          value
            .replace(/\s+/g, "")
            .replace(/([a-z0-9]{4})/gi, "$1 ")
            .trim()
            .toLocaleUpperCase()
        }
        customInput={TextInput}
        removeFormatting={(value) => value.replace(/\s+/gi, "")}
        isValidInputCharacter={(char) => /^[a-z0-9]$/i.test(char)}
        getCaretBoundary={(value) =>
          Array(value.length + 1)
            .fill(0)
            .map((v) => true)
        }
        onValueChange={(values, { event }) =>
          onChange(
            Object.assign({} as ChangeEvent<HTMLInputElement>, event, {
              target: {
                name: props.name,
                value: values.value.toLocaleUpperCase() ?? null,
              },
            }),
          )
        }
        onKeyDown={(e) =>
          !/^(?:[a-z0-9]|Backspace|Delete|Home|End|ArrowLeft|ArrowRight|Shift|CapsLock|Control|NumLock|Tab|Paste|Redo|Undo)$/i.test(
            e.key,
          ) && e.preventDefault()
        }
      />
    );
  },
);
